// extracted by mini-css-extract-plugin
export default {"pointContainer":"PointsList_pointContainer__7ehss","point":"PointsList_point__8jNZU","text":"PointsList_text__pcDP0"};